import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, tap } from 'rxjs/operators';
import { appName } from '@core/constants';

@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	constructor(private router: Router, private route: ActivatedRoute, private title: Title) {}

	/**
	 * Handle route changes: set page title
	 */
	onRouteChanged() {
		return this.router.events.pipe(
			filter((event) => event instanceof NavigationEnd),
			tap(() => {
				const title = this.getPageTitle();
				this.title.setTitle(title); // TODO: Dispatch action and handle this in store?
			}),
		);
	}

	/**
	 * Get page title based on current route.
	 */
	getPageTitle(): string {
		let child = this.route.firstChild;

		if (!child) {
			return `${this.route.snapshot.data.title} | ${appName}` || appName;
		}

		while (child.firstChild) {
			child = child.firstChild;
		}

		if (child.snapshot.data.title) {
			return `${child.snapshot.data.title} | ${appName}` || appName;
		}
	}
}
